/* eslint-disable import/no-cycle */
// TODO remove import cycles
import pickmeup from 'pickmeup/dist/pickmeup.min'; // pickMeUp plugin
import moment from 'moment/moment'; // moment.js plugin
import ShowMore from '../show-more/ShowMore';
import Form from '../form/form';
import Helpers from '../js/helpers';
import Search from '../search/search';
import ModalSearch from '../modal-search/modal-search';
import togglePreloader from '../prelodaer-search/prelodaer-search';
/* eslint-enable import/no-cycle */

moment.locale('RU');

export default new class Filter {
  constructor() {
    this.filter = '.filter';
    this.$modalBottom = $('.js-modalBottom');
    this.filterChooseDate = '.js-filterChooseDate';
    this.dateFilterReset = '.js-dateFilterReset';
    this.presetItem = '.js-filterPresetItem';
    this.filterBottom = '.filter__bottom';
    this.filterTooltip = '.filter__tooltip';
    this.filterCalendar = '.filter__calendar';
    this.filterCalendarText = '.filter__calendar-text';
    this.filterItem = '.js-filterItem';

    this.selectedYear = null;
    this.selectedJournal = null;

    this.sorting = '.sorting';
    this.sortingItem = '.sorting__item';

    this.filterSection = '.filter__section';
    this.filterSectionItem = '.filter__section-item';
    this.filterPreset = '.filter__preset';
    this.filterPresetItem = '.filter__preset-item';
    this.filterPayCheckboxItem = '.filter__checkbox-item';

    this.clearFilterTooltipBtn = '.filter__tooltip-clear';
    this.clearJournalTooltipBtn = '._clear-journal-filter';
    this.selectJournalBtn = '.filter__btn._all-journals';
    this.filterBtnText = '.filter__btn-text';
    this.journalTooltip = '.filter__journal-tooltip';
    this.filterSelectOuterJournalSelector = '.filter__select-outer._journal';

    this.portal = 'page-portal';
    this.journal = 'page-journal';

    this.activeClass = '_active';
    this.startDateSelectedClass = 'start-date-selected';

    this.dataValue = 'data-value';
    this.dataName = 'data-name';
    this.dataDefault = 'data-default';
    this.journalDataId = 'data-journal-id';
    this.dataStart = 'data-start';

    this.filterCalendarFrom = '.js-filterCalendarFrom';
    this.filterCalendarTo = '.js-filterCalendarTo';

    this.filterModalCalendarFrom = '.js-filterModalCalendarFrom';
    this.filterModalCalendarTo = '.js-filterModalCalendarTo';

    this.filterSubjournals = '.__subjournals';

    this.filterParams = {};

    //* *********FILTER PARAMS OPTIONS NAME
    this.journalParamName = 'journal';
    this.dateStartParamName = 'publish_from';
    this.dateEndParamName = 'publish_to';
    this.sortingParamName = 'sort';


    this.isYearSelected = false;
    this.isJournalSelected = false;

    this.journalList = {};

    this.dateFormat = 'YYYY-MM-DD';
    this.init();
  }

  init() {
    if ((!$(this.filter).length) || (document.body.getAttribute('data-page-id') == '404')) return;

    this.bindEvents();

    $.request('JournalData::onGetJournalList', {
      success: (response) => {
        this.journalList = response;
      },
    });
  }

  bindEvents() {
    $(document)
    // reset date filter
      .on('click', this.dateFilterReset, (e) => {
        e.stopPropagation();

        this.resetDateFilter();

        // set default page in change filter
        Search.page = 1;
        this.getFilterParams();
      })
      // get sorting params
      .on('click', this.sortingItem, (e) => {
        const $clickedItem = $(e.currentTarget);

        if (!$(e.currentTarget).hasClass(this.activeClass)) {
          const $sortingItemsArr = $clickedItem.closest(this.sorting).find(this.sortingItem);

          // set default page in change filter
          Search.page = 1;
          this.toggleItems($sortingItemsArr, $clickedItem);
          this.getFilterParams();
        }
      })
      // show/hide journal tooltip
      .on('click', this.selectJournalBtn, (e) => {
        e.stopPropagation();
        this.toggleJournalTooltip($(e.currentTarget));
      })
      // show/hide period tooltip
      .on('click', this.filterChooseDate, (e) => {
        this.toggleFilterTooltip($(e.currentTarget));
        this.setCalendarTypeAndInit();
      })
      // reset journal filter tooltip
      .on('click', this.clearJournalTooltipBtn, (e) => {
        e.stopPropagation();

        this.resetJournalFilter();

        // set default page in change filter
        Search.page = 1;
        this.getFilterParams();
      })
      // toggle preset item
      .on('click', this.filterPresetItem, (e) => {
        const $clickedItem = $(e.currentTarget);

        if (!$clickedItem.hasClass(this.activeClass)) {
          const $filterPresetItemsArr = $clickedItem
            .closest(this.filterPreset).find(this.filterPresetItem);

          this.toggleItems($filterPresetItemsArr, $clickedItem);
          this.clearSelectedDates();
          this.fillDateFilterBtn(null, null, $clickedItem.text());

          const $filter = this.getFilterType();
          $filter.find(`${this.presetItem}[${this.dataDefault}="true"]`).removeClass(this.startDateSelectedClass);

          // set default page in change filter
          Search.page = 1;
          this.getFilterParams();
        }
      })
      // set/change section filter
      .on('click', this.filterSectionItem, (e) => {
        const $clickedItem = $(e.currentTarget);

        if (!$clickedItem.hasClass(this.activeClass)) {
          const $filterSectionItemsArr = $clickedItem
            .closest(this.filter).find(this.filterSectionItem);

          this.toggleItems($filterSectionItemsArr, $clickedItem);
          this.toggleSelectJournalBtn($clickedItem);

          // set default page in change filter
          Search.page = 1;
          this.getFilterParams();
        }
      })
      // change paid plan
      .on('change', this.filterPayCheckboxItem, (e) => {
        this.setCheckedSubjournals($(e.target));
        // set default page in change filter
        Search.page = 1;
        this.getFilterParams();
      })
      // select year in journal filter
      .on('change', '.filter__select-outer._year select', (e) => {
        const selectedYear = e.currentTarget.value;
        this.selectedYear = selectedYear;
        this.selectedJournal = null;

        this.isYearSelected = true;
        this.fillYearSelect(this.setYearsList(), selectedYear);
        this.fillJournalSelect(this.setJournalList(selectedYear));
        this.fillJournalBtn();

        // set default page in change filter
        Search.page = 1;
        this.getFilterParams();
      })
      // select journal in journal filter
      .on('change', '.filter__select-outer._journal select', (e) => {
        this.isJournalSelected = true;
        this.fillJournalBtn(e);

        // set default page in change filter
        Search.page = 1;
        this.getFilterParams();
      })
      // close journal and date tooltip on body click
      .on('click', (e) => {
        if (!$(e.target).closest(this.filterTooltip).length
          && !$(e.target).closest('.filter__btn').hasClass('js-filterChooseDate')
          && !$(e.target).hasClass('js-filterChooseDate')
        ) {
          this.toggleFilterTooltip();
        }

        if (!$(e.target).closest(this.journalTooltip).length
          && !$(e.target).closest('.filter__btn').hasClass('_all-journals')
          && !$(e.target).hasClass('_all-journals')
        ) {
          this.toggleJournalTooltip();
        }
      });
  }

  setCalendarTypeAndInit() {
    if (this.getFilterType().hasClass('_search')) {
      this.initCalendar(this.filterModalCalendarFrom, this.filterModalCalendarTo, '_search');
    } else {
      this.initCalendar(this.filterCalendarFrom, this.filterCalendarTo, '_tag');
    }
  }

  /**
   * Set item section selected by index
   *
   * @param index - index of section item to set active
   */
  setDefaultSectionItemSelected(index = 0) {
    let $filterSectionItems;

    if (this.getFilterType().hasClass('_search')) {
      $filterSectionItems = $('.filter._search').find(this.filterItem);
    } else {
      $filterSectionItems = $('.tag-page__top').find(this.filterItem);
    }

    $filterSectionItems.removeClass(this.activeClass);
    $($filterSectionItems[index]).addClass(this.activeClass);
  }

  /**
   * Reset date in filter
   */
  resetDateFilter() {
    this.setDefaultPreset();
    this.clearSelectedDates();
    this.fillDateFilterBtn();
  }

  resetToDefaultValuesInSorrting($container = $('body')) {
    $container.find(`${this.sortingItem}`).removeClass(this.activeClass).filter('[data-default-value]').addClass(this.activeClass);
  }

  resetToDefaultValuesInCheckbox($container = $('body')) {
    $container.find(`${this.filterItem}`).prop('checked', false).filter('[data-default-value]').prop('checked', true);
  }

  /**
   * Reset journal filter
   */
  resetJournalFilter() {
    this.isYearSelected = false;
    this.isJournalSelected = false;
    this.selectedYear = null;
    this.selectedJournal = null;

    this.fillYearSelect(this.setYearsList());
    this.fillJournalSelect(this.setJournalList());
    this.fillJournalBtn();
  }

  /**
   *
   * @param currentYear -
   * @returns {Array} - arr of objects, journals
   */
  setJournalList(currentYearParam = null) {
    let currentYear = currentYearParam;

    if (!currentYear) {
      currentYear = moment(this.getToday()).format('YYYY');
    }

    return Object.keys(this.journalList)
      .filter(key => `${this.journalList[key].year}` === `${currentYear}`)
      .map(key => this.journalList[key]);
  }

  /**
   * Put selected journal in journal filter btn, or set journal filter btn to default
   */
  fillJournalBtn(event) {
    const $filter = this.getFilterType();
    const journalFilterBtn = $filter.find(this.selectJournalBtn);
    const journalFilterBtnText = journalFilterBtn.find(this.filterBtnText);

    if (this.isJournalSelected) {
      let selectedJournal;
      let selectedJournalId;

      // get selected journal
      if (event) {
        selectedJournal = event.currentTarget.selectedOptions[0].innerText;
        selectedJournalId = event.currentTarget.selectedOptions[0].value;
      } else {
        const $selected = $filter.find(this.filterSelectOuterJournalSelector).find('option[selected]')[0];
        selectedJournal = $selected.text;
        selectedJournalId = $selected.value;
      }
      this.selectedJournal = selectedJournalId;

      // get selected year
      const yearSelect = $filter.find('.filter__select-outer._year select');
      const selectedYear = yearSelect[0].selectedOptions[0].innerText;

      // write selected journal and year in journal filter btn
      journalFilterBtnText.text(`${selectedJournal} ${selectedYear}`);
      $filter.find(this.selectJournalBtn).addClass(this.activeClass);
      journalFilterBtn.attr(this.journalDataId, selectedJournalId);
    } else {
      // put default text in journal filter btn
      journalFilterBtnText.text('Выберите номер').addClass(this.activeClass);
      $filter.find(this.selectJournalBtn).removeClass(this.activeClass);

      journalFilterBtn.attr(this.journalDataId, '');
    }
  }

  /**
   * Get years for all journals
   *
   * @returns {Array} array of string, years of journals
   */
  setYearsList() {
    return [...new Set(Object.keys(this.journalList)
      .map(key => this.journalList[key].year))];
  }

  /**
   * get todays date
   *
   * @returns string - date in format yyyy-mm-dd
   */
  getToday() {
    return $('[data-today]').attr('data-today');
  }

  /**
   * Show/hide journal tooltip
   *
   * @param $target
   */
  toggleJournalTooltip($target) {
    if ($target) {
      const $journalTooltip = $target.closest(this.filter).find(this.journalTooltip);

      if ($journalTooltip.hasClass(this.activeClass)) {
        $journalTooltip.removeClass(this.activeClass);
      } else {
        $journalTooltip.addClass(this.activeClass);

        this.toggleFilterTooltip(null); // show journal tooltip
        this.fillYearSelect(this.setYearsList(), this.selectedYear);
        this.fillJournalSelect(this.setJournalList(this.selectedYear));
      }
    } else {
      const $journalTooltip = this.getFilterType().find(this.journalTooltip);
      $journalTooltip.removeClass(this.activeClass);
    }
  }

  fillYearSelect(arr, selectedYear) {
    const $filter = this.getFilterType();
    const $yearSelect = $filter.find('.filter__select-outer._year').find('select');

    $yearSelect.empty();

    if (!this.isYearSelected) {
      $yearSelect.append('<option disabled selected>Все года</option>');
    } else {
      $yearSelect.find('option[disabled]').remove();
    }

    arr.forEach((item) => {
      $yearSelect.append(`<option ${`${selectedYear}` === `${item}` ? 'selected' : ''} value="${item}">${item}</option>`);
    });

    Form.refreshSelectBox();
  }

  fillJournalSelect(arr) {
    const $filter = this.getFilterType();
    const $journalSelect = $filter.find(this.filterSelectOuterJournalSelector).find('select');
    const journalOption = (item, selected) => `<option ${selected ? 'selected ' : ''}value="${item.id}">${item.name}</option>`;

    $journalSelect.empty();

    if (this.isYearSelected) {
      $journalSelect.attr('disabled', false);
      $journalSelect.find('option[disabled]').remove();
      this.isJournalSelected = true;
    } else {
      $journalSelect.attr('disabled', true);
      $journalSelect.append('<option disabled selected>Выберите номер</option>');
    }

    arr.forEach((item, i) => {
      $journalSelect.append(
        journalOption(item, false),
      );

      if (this.isYearSelected && i === arr.length - 1) {
        $journalSelect.append(
          journalOption(item, true),
        );

        this.selectedJournal = item.id;
      }
    });

    Form.refreshSelectBox();
  }

  /**
   * Show/hide filter tooltip
   *
   * @param $target - jquery elem, clicked item
   */
  toggleFilterTooltip($target, params) {
    if ($target) {
      const $filterTooltip = $target.closest(this.filter).find(this.filterTooltip);
      if ($filterTooltip.hasClass(this.activeClass)) {
        $filterTooltip.removeClass(this.activeClass);
      } else {
        $filterTooltip.addClass(this.activeClass);
        this.toggleJournalTooltip(null, params); // hide journal tooltip
      }
    } else {
      const $filterTooltip = this.getFilterType().find(this.filterTooltip);
      $filterTooltip.removeClass(this.activeClass);
    }
  }

  /**
   * Toggle active item from arr of elems
   *
   * @param $itemsArr - arr of jquery objs
   * @param $activeItem - jquery obj of clicked item
   */
  toggleItems($itemsArr, $activeItem) {
    for (let i = 0; i < $itemsArr.length; i += 1) {
      const $currentItem = $($itemsArr[i]);
      const $clickedItemName = $activeItem.attr(this.dataValue);
      const $currentItemName = $currentItem.attr(this.dataValue);

      $currentItem.removeClass(this.activeClass);

      // set active item
      if ($clickedItemName === $currentItemName) {
        $currentItem.addClass(this.activeClass);
      }
    }
  }

  /**
   * Toggle select journal btn
   *
   * @param $clickedItem jquery obj of clicked item
   */
  toggleSelectJournalBtn($clickedItem) {
    const $selectJournalBtn = $clickedItem.closest(this.filter).find(this.selectJournalBtn);
    const $clickedItemName = $clickedItem.attr(this.dataValue);

    // show/hide select journal btn
    if ($clickedItemName === 'journal') {
      $selectJournalBtn.addClass('_show');
    } else {
      $selectJournalBtn.removeClass('_show');
      this.toggleJournalTooltip(null); // hide journal tooltip
      this.resetJournalFilter();
    }
  }

  /**
   * Hide select journal btn
   */
  hideSelectJournalBtn() {
    const $selectJournalBtn = this.getFilterType().find(this.selectJournalBtn);

    $selectJournalBtn.removeClass('_show');
    this.toggleJournalTooltip(null); // hide journal tooltip
    this.resetJournalFilter();
  }

  /**
   * Collect all filter params in object
   */
  getFilterParams(page = Search.page, isPaginationRequest) {
    const $filter = this.getFilterType();
    const $inputFilterArr = $filter.find(this.filterItem);

    $inputFilterArr.each((_, el) => {
      const $currentFilter = $(el);

      // get filter value from checkboxes (paid, free)
      if ($currentFilter[0].type === 'checkbox' || $currentFilter[0].type === 'radio') {
        if ($currentFilter.prop('checked')) {
            this.filterParams[$($currentFilter[0])
              .attr(this.dataName)] = $currentFilter.prop('checked');
        } else {
            delete this.filterParams[$($currentFilter[0]).attr(this.dataName)];
        }
      }

      if ($currentFilter.hasClass(this.activeClass)) {
        this.filterParams[$($currentFilter[0])
          .attr(this.dataName)] = $currentFilter.attr(this.dataValue);
      }
    });

    // get filter dates
    const $filterChooseDateBtn = $filter.find(this.filterChooseDate);
    const dateStart = $filterChooseDateBtn.attr(this.dataStart);
    const dateEnd = $filterChooseDateBtn.attr('data-end');

    if (dateStart) {
      this.filterParams[this.dateStartParamName] = dateStart;
    } else {
      delete this.filterParams[this.dateStartParamName];
    }

    if (dateEnd) {
      this.filterParams[this.dateEndParamName] = dateEnd;
    } else {
      delete this.filterParams[this.dateEndParamName];
    }

    // get filter selected journal id
    const $filterJournalFilterBtn = $filter.find(this.selectJournalBtn);
    const journalId = $filterJournalFilterBtn.attr(this.journalDataId);

    if (journalId) {
      this.filterParams[this.journalParamName] = journalId;
    } else {
      delete this.filterParams[this.journalParamName];
    }

    this.getPresetDates($filter);

    // get sort params
    this.getSortParams();
    // send filter request
    this.setFilterRequest(page, isPaginationRequest);
  }

  getPresetDates($filter) {
    const $selectedPresetItem = $filter.find(`${this.presetItem}.${this.activeClass}`);
    const $defaultPreset = $filter.find(`${this.presetItem}[${this.dataDefault}="true"]`);
    const $selectedPresetValue = $selectedPresetItem.attr(this.dataValue);

    if ($selectedPresetValue === 'all' && !$defaultPreset.hasClass(this.startDateSelectedClass)) {
      delete this.filterParams[this.dateStartParamName];
    } else if ($selectedPresetValue === 'less-2month') {
      if (!this.twoMonthAgo) {
        // get two month ago from today
        this.twoMonthAgo = moment(this.getToday());
        this.twoMonthAgo = this.twoMonthAgo.subtract(2, 'month').format(this.dateFormat);
      }
      this.filterParams[this.dateStartParamName] = this.twoMonthAgo;
    } else if ($selectedPresetValue === 'less-year') {
      if (!this.oneYearAgo) {
        // get one year ago from today
        this.oneYearAgo = moment(this.getToday());
        this.oneYearAgo = this.oneYearAgo.subtract(1, 'year').format(this.dateFormat);
      }
      this.filterParams[this.dateStartParamName] = this.oneYearAgo;
    }
  }

  /**
   * Add to filter params obj, params for sorting
   */
  getSortParams() {
    delete this.filterParams[this.sortingParamName];

    if (this.getFilterType().hasClass('_search')) {
      this.filterParams[this.sortingParamName] = $('.sorting._search').find(`.${this.activeClass}`).attr(this.dataValue);
    } else {
      this.filterParams[this.sortingParamName] = $('.sorting._tag-page').find(`.${this.activeClass}`).attr(this.dataValue);
    }
  }

  /**
   * Find active filter element
   *
   * @returns {*} jquery DOM obj of current filter element
   */
  getFilterType() {
    let $filter;
    const $searchModal = $('.modal-search.js-modal-content').closest('.modal');

    if ($searchModal.hasClass('modal_opened')) {
      // filter in search modal
      $filter = $searchModal.find(this.filter);
    } else {
      // filter in tag page
      $filter = $('.tag-page__top').find(this.filter);
    }

    return $filter;
  }

  /**
   * Separate request for search and for tag
   */
  setFilterRequest(page, isPaginationRequest) {
    if (this.getFilterType().hasClass('_search') || Helpers.isMobile()) {
      // search request
      const data = {filter: this.filterParams};
      let container = '.modal-search__container';

      data.search = $(Search.modalSearchInput).val();
      data.sort = this.filterParams.sort;
      data.page = page;

      if (page > 1) {
        container = `@${container}`;
      }

      togglePreloader(true, this.$modalBottom);
      ModalSearch.isRequestSent = true;


      $.request('ArticleList::onAjaxRequest', {
        url: window.location.origin + window.location.pathname,
        loading: '.sorting__preloader',
        data,
        update: {'project/common/modal-search/modal-search-result': container},
        success(response) {
          togglePreloader(false, this.$modalBottom);
          var _paq = window._paq || []
          _paq.push(['trackSiteSearch',
            data.search, false,false
          ]);
          this.success(response);
          ModalSearch.isRequestSent = false;

          const iPageMax = $('.modal-search__item').attr('data-search-max-page');
          ModalSearch.isLastPage = Search.page >= iPageMax;

          // scroll from bottom of search modal for better UX
          if (isPaginationRequest) {
            const $modalSearch = $('.modal-search');
            $modalSearch.scrollTop($modalSearch[0].scrollHeight - 1000);
          }

          ModalSearch.unbindScroll();
          ShowMore.initComponents(true);
        },
      });
    } else {
      // tag request
      const data = this.createFilterUrl(this.filterParams);

      // remove last slash from location.pathname
      const locationPathname = window.location.pathname;
      window.history.replaceState(null, null, window.location.origin + locationPathname + data);

      $.request('ArticleList::onAjaxRequest', {
        loading: '.articles__preloader',
        update: {
          'project/desktop/ajax/tag_article_list': '.articles__content_list',
          'project/desktop/ajax/tag_article_list_pagination': '.articles__content_list_pagination',
        },
        complete: () => {
          ShowMore.initComponents(true);
          ShowMore.initBindings(true);
        },
      });
    }
  }

  /**
   * Create url with filter params
   *
   * @param params - object of filter params
   * @returns {string} - string of request with get params created from params obj
   */
  createFilterUrl(params) {
    let requestString = '';

    if (params[this.sortingParamName]) {
      requestString += `?${this.sortingParamName}=${params[this.sortingParamName]}`;
    }

    Object.keys(params)
      .filter(key => key !== this.sortingParamName)
      .forEach((key) => {
        requestString += `&filter[${key}]=${params[key]}`;
      });

    return requestString;
  }

  /**
   * Destroy tag filter calendars
   */
  destroyTagFilterCalendar() {
    pickmeup(this.filterCalendarFrom).destroy();
    pickmeup(this.filterCalendarTo).destroy();
  }

  /**
   * Destroy search filter calendars
   */
  destroySearchFilterCalendar() {
    pickmeup(this.filterModalCalendarTo).destroy();
    pickmeup(this.filterModalCalendarFrom).destroy();
  }

  /**
   *  Init pickMeUpCalendar in filter
   *
   * @param calendarFrom - class of item to init 'calendar from' on it
   * @param calendarTo - class of item to init 'calendar to' on it
   * @param className - class to add to the calendar item, specified by filter type, search or tag
   * @returns {boolean}
   */
  initCalendar(calendarFrom, calendarTo, className) {
    if (!calendarFrom.length && !calendarTo.length) return;

    pickmeup.defaults.locales.ru = {
      days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
      daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    };

    const today = moment(this.getToday()).format('DD-MM-YYYY');

    // From
    pickmeup(calendarFrom, {
      locale: 'ru',
      hide_on_select: true,
      class_name: className,
      max: today,
    });

    // To
    pickmeup(calendarTo, {
      locale: 'ru',
      hide_on_select: true,
      class_name: className,
      max: today,
    });

    this.bindCalendarEvents(calendarFrom, calendarTo);
  }

  /**
   * Bind event listeners for calendars in filter
   */
  bindCalendarEvents(calendarFrom, calendarTo) {
    const tagFilterCalendarFrom = document.querySelector(calendarFrom);
    const tagFilterCalendarTo = document.querySelector(calendarTo);

    // From
    tagFilterCalendarFrom.addEventListener('pickmeup-change', (event) => {
      this.writeChosenDate(event);
      this.setDefaultPreset();

      this.dateStart = event.detail.date;
      this.fillDateFilterBtn(this.dateStart, this.dateEnd);

      const $filter = this.getFilterType();
      $filter.find(`${this.presetItem}[${this.dataDefault}="true"]`).addClass(this.startDateSelectedClass);

      // set default page in change filter
      Search.page = 1;
      this.getFilterParams();
    });

    // To
    tagFilterCalendarTo.addEventListener('pickmeup-change', (event) => {
      this.writeChosenDate(event);
      this.setDefaultPreset();

      this.dateEnd = event.detail.date;
      this.fillDateFilterBtn(this.dateStart, this.dateEnd);

      // set default page in change filter
      Search.page = 1;
      this.getFilterParams();
    });
  }

  /**
   * Write selected dates or date preset in filterChooseDate btn, or set the button to default
   *
   * @param dateStart - string, starting date for filter date tooltip
   * @param dateEnd - string, ending date for filter date tooltip
   * @param preset - string, selected preset name
   */
  fillDateFilterBtn(dateStart, dateEnd, preset) {
    const $filter = this.getFilterType();
    const $btn = $filter.find(this.filterChooseDate);
    const $btnText = $btn.find(this.filterBtnText);

    if (preset) {
      // write preset name in date filter btn
      $btnText.text(preset);
      $btn.addClass(this.activeClass);

      this.resetFilterCalendar($btn);
    } else if (dateStart || dateEnd) {
      // write dates in date filter btn
      $btnText.text(`с ${dateStart ? moment(dateStart).format('LL') : '...'} по ${dateEnd ? moment(dateEnd).format('LL') : '...'}`);

      $btn.attr(this.dataStart, dateStart ? moment(dateStart).format(this.dateFormat) : '');
      $btn.attr('data-end', dateEnd ? moment(dateEnd).format(this.dateFormat) : '');

      $btn.addClass(this.activeClass);
    } else {
      // clear date filter btn
      $btnText.text('Даты публикации');
      $btn.removeClass(this.activeClass);

      this.resetFilterCalendar($btn);
    }
  }

  /**
   * Reset selected dates in calendar
   */
  resetFilterCalendar($datesFilterBtnParam) {
    let $datesFilterBtn = $datesFilterBtnParam;

    if (Helpers.isMobile()) {
      return;
    }

    const $filter = this.getFilterType();

    if (this.getFilterType().hasClass('_search')) {
      this.destroySearchFilterCalendar();
    } else {
      this.destroyTagFilterCalendar();
    }

    this.setCalendarTypeAndInit();

    if (!$datesFilterBtn) {
      $datesFilterBtn = $filter.find(this.filterChooseDate);
    }

    $datesFilterBtn.attr(this.dataStart, '');
    $datesFilterBtn.attr('data-end', '');

    this.dateStart = null;
    this.dateEnd = null;
  }

  /**
   * Write chosen date in tooltip, hide calendar icon
   *
   * @param event - object of calendar change event
   */
  writeChosenDate(event) {
    const selectedDateStr = moment(event.detail.date).format('LL');
    const $calendarWrap = $(event.currentTarget);
    const $calendarText = $calendarWrap.find(this.filterCalendarText);

    $calendarWrap.addClass('_date-chosen');
    $calendarText.text(selectedDateStr);
  }

  /**
   * Clear selected dates text in calendar in tooltip, show calendar icon
   */
  clearSelectedDates() {
    $(this.filterCalendar).removeClass('_date-chosen');
    $(this.filterCalendarText).text('');

    this.resetFilterCalendar();
  }

  /**
   * Set preset in tooltip by default
   */
  setDefaultPreset() {
    const $filter = this.getFilterType();
    const $presetFilterItemsArr = $filter.find(this.filterPresetItem);
    const $defaultPreset = $filter.find(this.filterPreset).find(`[${this.dataDefault}]`);

    $presetFilterItemsArr.removeClass(this.activeClass);
    $defaultPreset.addClass(this.activeClass);
  }

  setCheckedSubjournals(target) {
    const obRz = $('input[data-name="rz"]');
    const obGms = $('input[data-name="gms"]');
    const obAll = $('input[data-name="all-subjournals"]');

    if (target.is(':checked')) {
      target.prop('checked', true);
    } else {
      target.prop('checked', false);
    }
    if (target.attr('data-name')==='all-subjournals' && target.is(':checked')) {
      obRz.prop('checked', true);
      obGms.prop('checked', true);
      obAll.prop('checked', true);
    } else if (target.attr('data-name')==='all-subjournals' && !target.is(':checked')) {
      obRz.prop('checked', false);
      obGms.prop('checked', false);
      obAll.prop('checked', false);
    } else if (target.attr('data-name')!=='all-subjournals' && !target.is(':checked')) {
      obAll.prop('checked', false);
    } else if (target.is(':checked') && obRz.is(':checked') && obGms.is(':checked')) {
      obAll.prop('checked', true);
    } else if (!target.is(':checked')) {
      obAll.prop('checked', false);
    }
  }
}();
